import { SSUType } from "../../types";
import { RecordSSUType } from "./recordDataTypes";

export const recordDataSSUTypePredicate = (
  arg: SSUType
): arg is RecordSSUType => {
  return (arg as RecordSSUType).relatedEntityData !== undefined;
};
